import { ReactElement } from 'react';
import { CircularProgress } from '@mui/material';

import { DialogIntegrationAssignWarehousesProps } from './types';
import DialogIntegrationAssignWarehousesProvider, {
  useDialogIntegrationAssignWarehousesContext,
} from './Context';
import DialogIntegrationAssignWarehousesContent from './Content';
import {
  DialogIntegrationAssignWarehousesContainer,
  DialogIntegrationAssignWarehousesLoadingContainer,
} from './styles';

const DialogIntegrationAssignWarehouses = (): ReactElement => {
  const { open, loadingStockLocations } =
    useDialogIntegrationAssignWarehousesContext();

  return (
    <DialogIntegrationAssignWarehousesContainer open={open}>
      {loadingStockLocations && (
        <DialogIntegrationAssignWarehousesLoadingContainer>
          <CircularProgress color="primary" disableShrink size={80} />
        </DialogIntegrationAssignWarehousesLoadingContainer>
      )}

      {!loadingStockLocations && <DialogIntegrationAssignWarehousesContent />}
    </DialogIntegrationAssignWarehousesContainer>
  );
};

const WrappedDialogIntegrationAssignWarehouses = (
  props: DialogIntegrationAssignWarehousesProps,
): ReactElement => {
  return (
    <DialogIntegrationAssignWarehousesProvider {...props}>
      <DialogIntegrationAssignWarehouses />
    </DialogIntegrationAssignWarehousesProvider>
  );
};

export default WrappedDialogIntegrationAssignWarehouses;
